






































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import ApiAdressePlugin from '@/components/plugins/ApiAdressePlugin.vue';
import MesurePlugin from '@/components/plugins/MesurePlugin.vue';
import LoadingInfosPlugin from '@/components/plugins/openlayers/LoadingInfosPlugin.vue';
import MousePositionPlugin from '@/components/plugins/openlayers/MousePositionPlugin.vue';
import ScalePlugin from '@/components/plugins/openlayers/ScalePlugin.vue';
import Plugin from '@/models/plugin/Plugin';
import { PluginLocation } from '@/models/plugin/PluginLocation';
import Component from 'vue-class-component';
import BaseComponent from '../BaseComponent';
import CesiumPlugin from '../plugins/CesiumPlugin.vue';
import BaseLayerSelectPlugin from '../plugins/BaseLayerSelectPlugin.vue';
import LocationPlugin from '../plugins/LocationPlugin.vue';
import DashBoardPlugin from '../plugins/DashBoardPlugin.vue';
import MapillaryPlugin from '../plugins/MapillaryPlugin.vue';
import ScaleListPlugin from '../plugins/ScaleListPlugin.vue';
import SearchLayerPlugin from '../plugins/SearchLayerPlugin.vue';
import NavigationPlugin from '../plugins/openlayers/NavigationPlugin.vue';
import FiltrePlugin from '../plugins/FiltrePlugin.vue';
import SwipePlugin from '../plugins/SwipePlugin.vue';
import ChartsPlugin from '../plugins/custom/ChartsPlugin.vue';
import MapService from '@/services/MapService';
import PanoramaxPlugin from '../plugins/PanoramaxPlugin.vue';
import IndicatorPlugin from '../plugins/custom/IndicatorPlugin.vue';

@Component({
  props: {
  },
  components: {
    ApiAdressePlugin,
    MousePositionPlugin,
    LoadingInfosPlugin,
    MesurePlugin,
    ScalePlugin,
    ScaleListPlugin,
    NavigationPlugin,
    MapillaryPlugin,
    PanoramaxPlugin,
    CesiumPlugin,
    FiltrePlugin,
    DashBoardPlugin,
    IndicatorPlugin,
    SearchLayerPlugin,
    LocationPlugin,
    BaseLayerSelectPlugin,
    ChartsPlugin,
    SwipePlugin,
  },
})
export default class MapPluginContainer extends BaseComponent {
    pluginsBR:Plugin[]=[];

    pluginsBL:Plugin[]=[];

    pluginsTL:Plugin[]=[];

    pluginsTR:Plugin[]=[];

    pluginsL:Plugin[]=[];
    created() {
      const requireComponent = require.context(
      // The relative path of the components folder
        '../plugins/',
        // Whether or not to look in subfolders
        true,
        // The regular expression used to match base component filenames
        /[A-Z]\w+\.(vue|js)$/,
      );

      requireComponent.keys().forEach((fileName:string) => {
        const componentConfig = requireComponent(fileName);
        console.log(componentConfig.default);
        // Gets the file name regardless of folder depth
        if (fileName && fileName.split('/') !== undefined) {
          const fileNameA = fileName.split('/');
          if (fileNameA && fileNameA.length > 0) {
            const fname = fileNameA.pop();
            if (fname && this.$options.components) {
              const componentName = fname.split('.')[0];
              // register the component locally
              this.$options.components[componentName] = componentConfig.default;
            }
          }
        }
      });
    }
    mounted() {
      // eslint-disable-next-line prefer-template
      console.log('Mount plugin components' + PluginLocation.TopLeft);
      this.pluginsL = this.pluginService.plugins.filter(
        (x:Plugin) => x.configuration.position === PluginLocation.Left,
      );
      console.log(this.pluginsL)
      this.pluginsTL = this.pluginService.plugins.filter(
        (x:Plugin) => x.configuration.position === PluginLocation.TopLeft,
      );

      this.pluginsTR = this.pluginService.plugins.filter(
        (x:Plugin) => x.configuration.position === PluginLocation.TopRight,
      );

      this.pluginsBR = this.pluginService.plugins.filter(
        (x:Plugin) => x.configuration.position === PluginLocation.BottomRight,
      );

      this.pluginsBL = this.pluginService.plugins.filter(
        (x:Plugin) => x.configuration.position === PluginLocation.BottomLeft,
      );

      if (this.getMapService() instanceof MapService){
        this.getOpenLayersMapService().setPrintContainer(this.$refs.ol_print);
      }
    }
}
